import React from 'react';
import LumosIconAndWordmark from '../LumosIconAndWordmark';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { PrimaryButton } from '../Button';
import { SvgIcon } from '../Icon';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import usePermission from '../../utils/hooks/permissionHooks';
import { appRoutes } from '../../path';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin: 16px;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;

const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary600};
`;

const Button = styled(PrimaryButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: ${theme.colors.purple500};
  color: ${theme.colors.purple500};
`;

const ExplainWithAiNotConfigured = () => {
  const navigate = useNavigate();
  const { checkIsPermitted } = usePermission();
  const isPermittedForAdmin = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminRead],
  });

  const handleRedirectToAdminSettings = () => {
    navigate(appRoutes.permission.settings);
  };

  const description = isPermittedForAdmin
    ? 'Looks like your OpenAI account isn’t set up. To configure OpenAI features you must enable AI in Admin settings.'
    : 'Your OpenAI account isn’t set up. Check with your admin to get started.';

  return (
    <Container>
      <Header>
        <LumosIconAndWordmark includeKubit={true} />
      </Header>

      <Body>
        <SvgIcon
          height={24}
          width={24}
          name="lumos"
          customFill={theme.colors.purple500}
        />
        <Title>Want smart AI-generated summaries?</Title>
        <Description>{description}</Description>

        {isPermittedForAdmin && (
          <Button onClick={handleRedirectToAdminSettings} isOutlined>
            Configure AI in admin settings
          </Button>
        )}
      </Body>

      <div />
    </Container>
  );
};

export default ExplainWithAiNotConfigured;
